import React from 'react';
import { Container, Typography } from '@mui/material';
import useStyles from '../styles';


const AboutMe = () => {

    const classes = useStyles();


    return (
        <Container className={classes.about_container}>
        <Typography color="secondary" variant='h4' >About Me</Typography>
            <Typography sx={{color: '#eeeeee'}} className={classes.about_me}  >
                I was born in Victoria, British Columbia and studied art at the Institute A
                llende in San Miguel de Allende, Mexico, and at the Victoria College of Art.
                Throughout the past 30 years I have produced works in graphic design, watercolour,
                paper-mache sculpture, acrylic and oil paintings on canvas. <br/><br/>My paintings are a
                collection of imaginative and representational realities that celebrate the glory
                innate in nature. Working with a vibrant palette provides me with an unlimited
                opportunity to represent the interactive life of colour. In moving beyond right
                doing and wrong doing there is a place to record personal interpretive journeys,
                a place of integrating creative expression, theory, and the collective inspiration
                from artists past and present. This calling of creativity and connection with nature
                evokes a sense of belonging and fullness.<br/> <br/> And, it is this feeling that I hope to share
                my paintings.
            </Typography>
            
        </Container>
    )
}

export default AboutMe
